// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '16.529px',
  height: '16.529px',
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

// Component
function IconInfomation({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16.529 16.529"
    >
      <path
        className="a"
        fill="#5badfa"
        d="M8.264,0a8.265,8.265,0,1,0,8.265,8.264A8.265,8.265,0,0,0,8.264,0Zm1.72,12.809q-.638.252-1.018.383a2.686,2.686,0,0,1-.883.132,1.76,1.76,0,0,1-1.2-.377,1.217,1.217,0,0,1-.427-.956,3.474,3.474,0,0,1,.031-.461c.022-.157.056-.333.1-.531l.532-1.881c.047-.181.087-.352.12-.511a2.268,2.268,0,0,0,.048-.443.682.682,0,0,0-.148-.5.843.843,0,0,0-.569-.141,1.493,1.493,0,0,0-.423.063c-.143.044-.268.084-.37.123l.141-.579q.523-.213,1-.365a2.956,2.956,0,0,1,.9-.153,1.727,1.727,0,0,1,1.184.371,1.232,1.232,0,0,1,.416.963q0,.123-.029.432a2.889,2.889,0,0,1-.106.567l-.53,1.875c-.043.15-.082.323-.117.515a2.723,2.723,0,0,0-.051.438.629.629,0,0,0,.167.509.936.936,0,0,0,.579.136,1.678,1.678,0,0,0,.438-.068,2.49,2.49,0,0,0,.354-.119ZM9.891,5.2A1.264,1.264,0,0,1,9,5.542,1.277,1.277,0,0,1,8.1,5.2a1.1,1.1,0,0,1-.373-.835A1.11,1.11,0,0,1,8.1,3.526,1.268,1.268,0,0,1,9,3.179a1.254,1.254,0,0,1,.892.348,1.127,1.127,0,0,1,0,1.671Z"
      />
    </svg>
  )
}

IconInfomation.defaultProps = defaultProps
IconInfomation.propTypes = propTypes

export default IconInfomation
